<template>
  <div v-if="!getHideNotification">
    <div
      class="notification-block fs-12"
      v-if="showStoreClosing"
      :style="storeClosingStyles"
    >
      <div class="notification-block-icon">
        <img :src="modulePropsData.storeClosingClockIcon" class="width100" />
      </div>
      <div
        class="notification-block-content"
        v-html="modulePropsData.titleStoreClosing"
      ></div>
      <div class="clock-ticker" :style="clockTickerStyles">
        <div class="timer fw-700">
          <span class="fs-10 fw-500">Closes In</span>
          {{ getTime }}
        </div>
      </div>
    </div>
    <div
      class="notification-block fs-12 has-close"
      v-else-if="sgInfo?.eventDetails"
      :style="sgOnfoStyles"
    >
      <VueLottiePlayer
        name="confettiAnim1"
        width="100%"
        class="notification-block-lottie"
        height="100%"
        v-if="showLottie"
        loop
        :path="lottiePath"
      />
      <div
        class="notification-block-content"
        v-html="sgInfo?.eventDetails?.messages[0].displayMessage"
      ></div>
      <i
        class="notification-block-close-icon hkfi-close-thin fs-24"
        :style="closeIconStyle"
        @click="closeNotification"
      ></i>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility.js";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsAction } from "../helpers/storeKeys.js";
import { clientPlatform } from "../config/apiEndpoints";
import localStorageFunc from "../helpers/localStorageFunc";
import {
  EVENT_HOMEPAGE_ALERT,
  EVENT_POPUP,
} from "../helpers/analyticsEvents.js";

export default {
  name: "NotificationWidget",
  components: {
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  props: ["moduleProps"],
  data() {
    return {
      clientPlatform,
      animationInstance: {},
      modulePropsData: {},
      inView: false,
      deg: 0,
      degUnitSec: 1,
      hideNotification: false,
      timeoutId: {},
      currentTimeLeft: 0,
    };
  },
  mounted() {
    this.$store.dispatch(keyMapsAction.SG_INFO_API, {});
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    this.hideNotification = LocalStorageFunc.getSessionStorageKey(
      "hideNotification",
      false
    );
    this.setInitialDataForClock();
  },
  unmounted() {
    clearTimeout(this.timeoutId);
  },
  methods: {
    setInitialDataForClock() {
      this.degUnitSec =
        (this.modulePropsData.storeClosingNotificationThreshold * 60) / 360;
      this.setCurrentTimeDiff();
      const tick = () => {
        this.currentTimeLeft -= 1;

        if (this.currentTimeLeft > 0) {
          this.timeoutId = setTimeout(tick, 1000);
        } else {
          // Countdown finished
          clearTimeout(this.timeoutId);
        }
      };

      tick();
    },
    closeNotification() {
      this.hideNotification = true;
      EVENT_HOMEPAGE_ALERT({
        userAction: "close alert",
        subcategory:
          Utility.stripHtmlTagsRegex(this.modulePropsData.titleStoreClosing) ||
          Utility.stripHtmlTagsRegex(
            this.$store.state.Cart.sgInfo.eventDetails?.messages[0]
              .displayMessage
          ),
      });
      localStorageFunc.setSessionStorageKey("hideNotification", true);
    },
    setCurrentTimeDiff() {
      this.currentTimeLeft = Utility.getTimeDifferenceInSeconds(
        LocalStorageFunc.getLastLocationNew()?.[0]?.recent
          ?.storeOperationalEndTime
      );
    },
  },
  watch:{
    showStoreClosing: {
      handler(newVal, oldVal){
        if(newVal != oldVal && newVal){
          EVENT_POPUP({
            subcategory: 'alert',
            errorMessage: Utility.stripHtmlTagsRegex(this.modulePropsData.titleStoreClosing)
          });
          EVENT_HOMEPAGE_ALERT({
            userAction:'impression',
            subcategory: Utility.stripHtmlTagsRegex(this.modulePropsData.titleStoreClosing)
          });
        }
      }
    },
    sgInfo: {
      handler(newVal, oldVal){
        if(newVal.eventDetails?.messages[0]?.displayMessage != oldVal.eventDetails?.messages[0]?.displayMessage && newVal.eventDetails?.messages[0]?.displayMessage && !this.showStoreClosing){
          EVENT_POPUP({
            subcategory: 'alert',
            errorMessage: Utility.stripHtmlTagsRegex(newVal.eventDetails?.messages[0]?.displayMessage)
          });
          EVENT_HOMEPAGE_ALERT({
            userAction:'impression',
            subcategory: Utility.stripHtmlTagsRegex(newVal.eventDetails?.messages[0]?.displayMessage)
          });
        }
      }
    }
  },
  computed: {
    getDegree() {
      return 360 - this.currentTimeLeft / this.degUnitSec;
    },
    getTime() {
      return `${Math.floor(this.currentTimeLeft / 60)}:${
        this.currentTimeLeft % 60 < 10
          ? `0${this.currentTimeLeft % 60}`
          : this.currentTimeLeft % 60
      }`;
    },
    showStoreClosing() {
      return this.currentTimeLeft > 0 && this.currentTimeLeft<this.modulePropsData.storeClosingNotificationThreshold * 60;
    },
    sgInfo() {
      return this.$store.state.Cart.sgInfo;
    },
    checkLottieURL() {
      return Utility.checkForImage(
        this.sgInfo.eventDetails?.messages[0].properties.backgroundLottieUrl
      );
    },
    getHideNotification() {
      return this.hideNotification;
    },
    storeClosingStyles() {
      return {
        backgroundImage: `linear-gradient(to right,${this.modulePropsData.bgGradientColor1},${this.modulePropsData.bgGradientColor2})`,
      };
    },
    clockTickerStyles() {
      return {
        backgroundImage: `conic-gradient(${this.modulePropsData.clockActiveColor} ${this.getDegree}deg,${this.modulePropsData.clockInactiveColor} 0deg)`,
      };
    },
    sgOnfoStyles() {
      return {
        backgroundImage: this.checkLottieURL
          ? `url(${this.sgInfo.eventDetails?.messages[0].properties.backgroundLottieUrl})`
          : `linear-gradient(to right,${this.sgInfo.eventDetails?.messages[0].properties.gradientTopColor},${this.sgInfo.eventDetails?.messages[0].properties.gradientBottomColor})`,
      };
    },
    closeIconStyle() {
      return { color: this.modulePropsData.closeIconColor };
    },
    showLottie() {
      return this.sgInfo.eventDetails?.messages[0].properties.backgroundLottieUrl?.includes(
        ".txt"
      );
    },
    lottiePath() {
      return this.sgInfo.eventDetails?.messages[0].properties
        .backgroundLottieUrl;
    },
  },
};
</script>
